import React from 'react';
import styled from '@emotion/styled';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Typography,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Switch
} from '@mui/material';
import { ExpandMore, Delete } from '@mui/icons-material';

const StyledFormTextField = styled(TextField)`
  margin-top: 4px;
  margin-bottom: 4px;
`;

function ProfileDestinationAccordion({ destination, index, updateDestination, removeDestination, errors }) {

    const getError = (field) => errors && errors[`destinations.${index}.${field}`];


    return (
        <Accordion key={index} defaultExpanded={false}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Destination Address {index + 1}</Typography>
                <IconButton onClick={() => removeDestination(index)} size="small" style={{ marginLeft: 'auto' }}>
                    <Delete color="error" />
                </IconButton>
            </AccordionSummary>

            <AccordionDetails>
                {/* Radio Group for Destination Type */}
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography>Destination Type</Typography>
                        <RadioGroup
                            row
                            value={destination.message_type}
                            onChange={(e) => updateDestination(index, 'message_type', e.target.value)}
                        >
                            <FormControlLabel
                                value="email"
                                control={<Radio color="primary" />}
                                label="Email"
                            />
                            <FormControlLabel
                                value="SFTP"
                                control={<Radio color="primary" />}
                                label="SFTP"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>

                {/* Conditional Fields based on Type */}
                {destination.message_type === 'email' && (
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <StyledFormTextField
                                label="Email Address"
                                value={destination.email ?? ''}
                                onChange={(e) => updateDestination(index, 'email', e.target.value)}
                                fullWidth
                                margin="normal"
                                error={Boolean(getError('email'))}
                                helperText={getError('email')}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <StyledFormTextField
                                label="Attachment Password"
                                value={destination.attachment_password || ''}
                                onChange={(e) =>
                                    updateDestination(index, 'attachment_password', e.target.value)
                                }
                                fullWidth
                                margin="normal"
                                type={destination.showPassword ? 'text' : 'password'}
                                error={Boolean(getError('attachment_password'))}
                                helperText={getError('attachment_password')}
                            />
                        </Grid>
                    </Grid>
                )}

                {/* SFTP Fields */}
                {destination.message_type === 'SFTP' && (
                    <Grid container spacing={2}>
                        <Grid item xs={12} container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField
                                        label="IP Address"
                                        value={destination.ip_address ?? ''}
                                        onChange={(e) =>
                                            updateDestination(index, 'ip_address', e.target.value)
                                        }
                                        fullWidth
                                        margin="normal"
                                        error={Boolean(getError('ip_address'))}
                                        helperText={getError('ip_address')}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField
                                        label="Port"
                                        type="number"
                                        value={destination.tcp_port ?? ''}
                                        onChange={(e) =>
                                            updateDestination(index, 'tcp_port', Number(e.target.value))
                                        }
                                        fullWidth
                                        margin="normal"
                                        error={Boolean(getError('tcp_port'))}
                                        helperText={getError('tcp_port')}
                                    />
                                </Grid>
                        </Grid>

                        <Grid item xs={12} container spacing={3}>
                                <Grid item xs={4}>
                                    <StyledFormTextField
                                        label="Username"
                                        value={destination.user_name ?? ''}
                                        onChange={(e) =>
                                            updateDestination(index, 'user_name', e.target.value)
                                        }
                                        fullWidth
                                        margin="normal"
                                        error={Boolean(getError('user_name'))}
                                        helperText={getError('user_name')}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color="primary" >Authentication Type</Typography>
                                    <RadioGroup
                                        row
                                        value={destination.auth_type}
                                        onChange={(e) => updateDestination(index, 'auth_type', e.target.value)}
                                    >
                                        <FormControlLabel
                                            value="Password"
                                            control={<Radio color="primary" />}
                                            label="Password"
                                        />
                                        <FormControlLabel
                                            value="Key"
                                            control={<Radio color="primary" />}
                                            label="Private key"
                                        />
                                    </RadioGroup>
                                </Grid>
                        </Grid>


                        <Grid item xs={12} container spacing={3}>
                                
                                    {destination.auth_type === 'Password' && (
                                        <Grid item xs={4}>
                                            <StyledFormTextField
                                                label="Password"
                                                value={destination.ftp_password ?? ''}
                                                onChange={(e) =>
                                                    updateDestination(index, 'ftp_password', e.target.value)
                                                }
                                                fullWidth
                                                margin="normal"
                                                type="password"
                                                error={Boolean(getError('ftp_password'))}
                                                helperText={getError('ftp_password')}
                                            />
                                        </Grid>
                                    )}

                                    {destination.auth_type === 'Key' && (
                                        <Grid item xs={12} container spacing={3}>
                                            
                                                <Grid item xs={5}>
                                                    <StyledFormTextField
                                                        label="Private key"
                                                        value={destination.private_key ?? ''}
                                                        onChange={(e) =>
                                                            updateDestination(index, 'private_key', e.target.value)
                                                        }
                                                        fullWidth
                                                        margin="normal"
                                                        error={Boolean(getError('private_key'))}
                                                        helperText={getError('private_key')}
                                                    />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={destination.private_key_encrypted}
                                                                onChange={(e) =>
                                                                    updateDestination(
                                                                        index,
                                                                        'private_key_encrypted',
                                                                        e.target.checked
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Private key is encrypted"
                                                    />
                                                </Grid>
                                                {destination.private_key_encrypted && (
                                                    <Grid item xs={4}>
                                                        <StyledFormTextField
                                                            label="Private key password"
                                                            value={destination.private_key_password ?? ''}
                                                            onChange={(e) =>
                                                                updateDestination(index, 'private_key_password', e.target.value)
                                                            }
                                                            fullWidth
                                                            margin="normal"
                                                            error={Boolean(getError('private_key_password'))}
                                                            helperText={getError('private_key_password')}
                                                        />
                                                    </Grid>
                                                )}

                                        </Grid>
                                    )}

                        </Grid>

                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={destination.verify_host_key}
                                        onChange={(e) =>
                                            updateDestination(
                                                index,
                                                'verify_host_key',
                                                e.target.checked
                                            )
                                        }
                                        color="primary"
                                    />
                                }
                                label="Verify host key fingerprint"
                            />
                        </Grid>
                        <Grid item xs={6}>
                        {destination.verify_host_key && (
                            <StyledFormTextField
                            label="SHA-256 Fingerprint"
                            value={destination.host_key_fingerprint  ?? ''}
                            onChange={(e) =>
                                updateDestination(index, 'host_key_fingerprint', e.target.value)
                            }
                            fullWidth
                            margin="normal"
                        />
                        )}
                        </Grid>


                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={destination.compress_attachment}
                                        onChange={(e) =>
                                            updateDestination(
                                                index,
                                                'compress_attachment',
                                                e.target.checked
                                            )
                                        }
                                        color="primary"
                                    />
                                }
                                label="Compress Attachment as ZIP file"
                            />
                        </Grid>
                        <Grid item xs={6}>
                        {destination.compress_attachment && (
                            <StyledFormTextField
                            label="Attachment Password"
                            value={destination.attachment_password ?? ''}
                            onChange={(e) =>
                                updateDestination(index, 'attachment_password', e.target.value)
                            }
                            fullWidth
                            margin="normal"
                        />
                        )}
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={destination.use_partial_file_extension}
                                        onChange={(e) =>
                                            updateDestination(
                                                index,
                                                'use_partial_file_extension',
                                                e.target.checked
                                            )
                                        }
                                        color="primary"
                                    />
                                }
                                label="Use temporary file extension while transferring"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={destination.transfer_ready_file}
                                        onChange={(e) =>
                                            updateDestination(
                                                index,
                                                'transfer_ready_file',
                                                e.target.checked
                                            )
                                        }
                                        color="primary"
                                    />
                                }
                                label="Create ready file after transfer"
                            />
                        </Grid>


                        <Grid item xs={4}>
                            <StyledFormTextField
                                label="Remote Directory"
                                value={destination.remote_directory  ?? ''}
                                onChange={(e) =>
                                    updateDestination(index, 'remote_directory', e.target.value)
                                }
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        
                        {/* Add additional SFTP fields as needed */}
                    </Grid>
                )}

            </AccordionDetails>
        </Accordion>
          );
        }
        
        export default ProfileDestinationAccordion;